module.exports = __webpack_public_path__ + "assets/icon-nav-funnel-component.46a48157.svg";